import { render, staticRenderFns } from "./PayResultCheck.vue?vue&type=template&id=e48460a4&scoped=true"
import script from "./PayResultCheck.vue?vue&type=script&lang=js"
export * from "./PayResultCheck.vue?vue&type=script&lang=js"
import style0 from "./PayResultCheck.vue?vue&type=style&index=0&id=e48460a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48460a4",
  null
  
)

export default component.exports